import type { AxiosError } from 'axios';
import axios from 'axios';
import config from 'config/config';
import { CUSTOMER_INFO } from 'const/local-storage';
import posthog from 'posthog-js';
import type { Customer } from 'types';

declare const VERSION: string;

const getCustomerInfo = async (): Promise<Customer | undefined> => {
  const customerSessionInfo = localStorage.getItem(CUSTOMER_INFO);
  if (customerSessionInfo) {
    return JSON.parse(customerSessionInfo);
  }
  if (config.env !== 'production') {
    return {
      city: 'Coruscant',
      ip: '127.0.0.1',
      latitude: '0',
      longitude: '0'
    };
  }
  try {
    const { data } = await axios.get<Customer>('https://api.ipgeolocation.io/ipgeo', {
      params: { apiKey: `2f1efb5338294fffa4b2ecc5ea38863e` }
    });

    localStorage.setItem(CUSTOMER_INFO, JSON.stringify(data));
    return data;
  } catch (e) {
    posthog?.capture('getCustomerInfoFailed', { error: (e as AxiosError).message, version: VERSION });
    console.warn(`IPGO failed message: ${(e as AxiosError).message}`);
  }
};

export default getCustomerInfo;
